@mixin input-position {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}
$checkbox-size: 24px;
$checked-icon: "data:image/svg+xml,%3Csvg width='19' height='14' viewBox='0 0 19 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.9571 1.04289C18.3476 1.43342 18.3476 2.06658 17.9571 2.45711L7.45711 12.9571C7.06658 13.3476 6.43342 13.3476 6.04289 12.9571L0.792893 7.70711C0.402369 7.31658 0.402369 6.68342 0.792893 6.29289C1.18342 5.90237 1.81658 5.90237 2.20711 6.29289L6.75 10.8358L16.5429 1.04289C16.9334 0.652369 17.5666 0.652369 17.9571 1.04289Z' fill='black'/%3E%3C/svg%3E%0A";
$checked-icon-size: calc($checkbox-size - 6px);

:host {
  display: flex;
  align-items: center;
  position: relative;

  padding-left: $checkbox-size !important;
  height: $checkbox-size;

  & > input {
    appearance: none;
    visibility: hidden;
    @include input-position;
  }

  &::before {
    content: "";
    @include input-position;  

    width: $checkbox-size;
    height: $checkbox-size;
    border-width: 1px;
    border-style: solid;
    border-radius: $size-radius-xxs;
  }
  
  &::after {
    content: "";
    @include input-position;

    width: calc($checkbox-size + 2px);
    height: calc($checkbox-size + 2px);
    border-width: 1px;

    background-repeat: no-repeat;
    background-color: $color-base-brand-black;

    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: $checked-icon-size;
    mask-image: url($checked-icon);
    
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: $checked-icon-size;
    -webkit-mask-image: url($checked-icon);

    visibility: hidden;
  }

  smart-text {
    margin-left: $size-space-sm;
    align-items: center;
  }
}

:host(.checked) {
  &::after {
    visibility: visible;
  }
}

:host(.primary) {
  &::before {
    border-color: $color-base-gray-gray-5;
  }

  &.disabled {
    &::before {
      border-color: $color-base-gray-gray-3;
      background-color: $color-base-gray-gray-1;
    }

    smart-text {
      color: $color-typography-typo-48 !important;
    }
  }
}